import type { SVGProps } from "react";

export default function EyeScanIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M6.66643 14.6667C4.15227 14.6667 2.8952 14.6667 2.11415 13.8857C1.3331 13.1047 1.3331 12.5142 1.3331 10.0001"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M14.666 10.0001C14.666 12.5142 14.666 13.1047 13.8849 13.8857C13.1039 14.6667 11.8468 14.6667 9.33268 14.6667"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M9.33268 1.33346C11.8468 1.33346 13.1039 1.33346 13.8849 2.11451C14.666 2.89556 14.666 3.48597 14.666 6.00013"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M6.66643 1.33346C4.15227 1.33346 2.8952 1.33346 2.11415 2.11451C1.3331 2.89556 1.3331 3.48597 1.3331 6.00013"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M3.92777 9.37344C3.53114 8.91338 3.33282 8.68331 3.33282 8.00024C3.33282 7.31718 3.53113 7.08711 3.92777 6.62705C4.71973 5.70839 6.04794 4.66691 7.99948 4.66691C9.95102 4.66691 11.2792 5.70839 12.0712 6.62705C12.4678 7.08711 12.6662 7.31718 12.6662 8.00024C12.6662 8.68331 12.4678 8.91338 12.0712 9.37344C11.2792 10.2921 9.95102 11.3336 7.99948 11.3336C6.04794 11.3336 4.71974 10.2921 3.92777 9.37344Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M7.9996 9.3333C8.73598 9.3333 9.33293 8.73634 9.33293 7.99996C9.33293 7.26358 8.73598 6.66663 7.9996 6.66663C7.26322 6.66663 6.66627 7.26358 6.66627 7.99996C6.66627 8.73634 7.26322 9.3333 7.9996 9.3333Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
